module.exports = __webpack_public_path__ + "assets/img/solution9.1473d3b1.png";